import { render, staticRenderFns } from "./IconLogoutRounded.vue?vue&type=template&id=20eabbe4&"
import script from "./IconLogoutRounded.vue?vue&type=script&lang=js&"
export * from "./IconLogoutRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports